import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './AppV3';
import { I18nProvider } from './i18n';
import { installApiErrorHandling } from './services/api/errors';
import './diagnostic-history-wrapper';

installApiErrorHandling();

// Unregister any service workers from previous deployments.
// The new build does NOT use a service worker. Old SW from the previous
// PWA build intercepts fetch requests and serves stale cached content,
// causing the old frontend to persist even after server updates.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().then(() => {
        console.log('[SW] Unregistered old service worker:', registration.scope);
      });
    });
    // Clear all caches left by old service worker
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
          console.log('[SW] Deleted cache:', cacheName);
        });
      });
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>
);

